import React, { MouseEventHandler } from 'react';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import customersLogo from 'assets/logo-customers-blue.svg';
import './Logo.pcss';
import { useWhitelabelConfig } from '@mm/hooks/src/use-whitelabel-config';

type Props = {
  className?: string;
  href?: string;
  onClick?: MouseEventHandler<HTMLElement>;
};

export const Logo = ({ className, href, onClick }: Props) => {
  const { companyLogo, companyName = 'Customers.ai' } = useWhitelabelConfig();
  const image = companyLogo || (
    <img
      className="navigation-bar__logo-image"
      alt="Customers.ai Logo"
      src={customersLogo}
    />
  );

  const containerClassname = classNames(className, 'navigation-bar__logo');

  return href ? (
    <Link to={href} className={containerClassname} onClick={onClick}>
      {image}
      {companyName}
    </Link>
  ) : (
    <div className={containerClassname} onClick={onClick}>
      {image}
    </div>
  );
};
